/* eslint-disable max-statements */
import React from "react";
import styles from "./styles.css";
// import PropTypes from "prop-types";
import FairWearAndTear from "./images/fair_wear_and_tear.png";
import ThreeHundredPointInspection from "./images/300-point-inspection.png";
import ImperfectionWearAndTear from "./images/imperfection-wear-tear.png";
import LazyImage from "../../../components/shared/lazy-image";

const QUALITY_PROMISE_VALUES = [
    {
        key: "cars24QualityStandards",
        description: "Condition is assessed to identify imperfections vs fair wear and tear.",
        linkDescription: "See fair wear & tear standards",
        image: FairWearAndTear,
        name: "Fair Wear Tear",
        nameKey: "fairWearTear",
        hrefKey: "wearAndTearGuideLink",
        link: "/blog/car-quality-standards-cars24/",
        isRelative: false
    },
    {
        key: "threeHundredPointInspection",
        description: "Have cleared our 300 point car inspection by qualified CARS24 Expert.",
        linkDescription: "See our 300 point inspection",
        image: ThreeHundredPointInspection,
        name: "300 point inspection",
        nameKey: "pointInspection",
        hrefKey: "",
        link: "/300-point-inspection",
        isRelative: true
    },
    {
        key: "imperfectionGuide",
        description: "Guide to understand how we assess the condition of your car.",
        linkDescription: "Imperfection and wear/tear guide",
        image: ImperfectionWearAndTear,
        name: "Fair Wear Tear",
        nameKey: "fairWearTear",
        hrefKey: "wearAndTearGuideLink",
        link: "/blog/car-quality-standards-cars24/",
        isRelative: false
    }
];

const QualityPromiseInfoSection = () => {

    return (
        <div styleName={"styles.leftWrapper"}>
            <h3 styleName={"styles.featureHeading"}>Car imperfections</h3>
            <p styleName={"styles.subHeading"}>This section provides an honest overview of any imperfections in the vehicle. It aims to ensure full transparency about the car's condition, helping you make an informed decision with clarity and confidence.</p>
            <div styleName={"styles.qualityAssuredWrapper"}>
                {QUALITY_PROMISE_VALUES.map((data) => {
                    const {key, description, linkDescription, image, link} = data;
                    return  (
                        <div key={key} styleName={"styles.qualityAssuredItem"}>
                            <LazyImage styleName={`styles.${key}`} src={image} height={40} width={40} />
                            <div styleName={"styles.qualityAssuranceLinkContainers"}>
                                <p>{description}</p>
                                <a href={link} target="_blank">{linkDescription}</a>
                            </div>
                        </div>
                    );
                })}
            </div>

        </div>
    );
};

QualityPromiseInfoSection.propTypes = {};

export default QualityPromiseInfoSection;
